import React from "react";
import { Form, InputNumber } from "antd";

const PriceNoNds = ({ form, disabled }) => {
  const { getFieldDecorator } = form;

  return (
    <div className="offer-card__item">
      <span className="label">
        <span>Цена основной услуги (без&nbsp;НДС), руб.:</span>
      </span>
      <Form.Item>
        {getFieldDecorator("priceNoNds", {
          rules: [
            {
              required: true,
              message: "Поле, обязательное для заполнения"
            }
          ]
        })(
          <InputNumber
            placeholder="Укажите стоимость услуги"
            style={{ width: 224 }}
            disabled={disabled}
          />
        )}
      </Form.Item>
    </div>
  );
};

export default PriceNoNds;
